import React, { useState } from 'react';
import './Offers.css';

export default function Offers() {
  const [activeTab, setActiveTab] = useState('all');

  const offers = [
    {
      id: 1,
      category: 'FLIGHTS',
      title: 'LIVE NOW: Deals for Students',
      description: 'Up to 30% OFF* on International Flights, Hotels & More.',
      image: '/assets/595550415.jpeg',
      button: 'BOOK NOW',
      tag: "T&C'S APPLY",
    },
    {
      id: 2,
      category: 'HOTELS',
      title: 'Book Ramoji Hotels @ Up to 35% OFF*',
      description: 'For a Luxurious, Comfortable and Elegant Stay!',
      image: '/assets/595550229.jpeg',
      button: 'BOOK NOW',
      tag: "T&C'S APPLY",
    },
    {
      id: 3,
      category: 'FLIGHTS',
      title: 'For All Travel Moods: Up to 40% OFF*',
      description: 'on Flights, Stays, Packages, Buses, Trains, Cabs & More!',
      image: '/assets/595550178.jpeg',
      button: 'BOOK NOW',
      tag: "T&C'S APPLY",
    },
    {
      id: 4,
      category: 'HOTELS',
      title: 'FOR UNFORGETTABLE STAYS IN INDIA:',
      description: 'Book Amritara Hotels & Resorts @ Up to 40% OFF*',
      image: '/assets/45450075.jpeg',
      button: 'VIEW DETAILS',
      tag: "T&C'S APPLY",
    },
  ];

  const tabs = ['All Offers', 'Bank Offers', 'Flights', 'Hotels', 'Holidays', 'Trains', 'Cabs', 'Bus', 'Forex'];

  return (
    <section className="block offers-section">
      <div className="container">
        <div className="offers-header">
          <div className="section-head">
            <h2>Offers</h2>
          </div>
          <div className="offers-tabs">
            {tabs.map((tab) => (
              <button
                key={tab}
                className={`tab ${activeTab === tab.toLowerCase() ? 'active' : ''}`}
                onClick={() => setActiveTab(tab.toLowerCase())}
              >
                {tab}
              </button>
            ))}
            <button className="tab more-btn">MORE ▼</button>
          </div>
          <a href="/" className="view-all">VIEW ALL ➜</a>
        </div>

        <div className="offers-grid">
          {offers.map((offer) => (
            <div key={offer.id} className="offer-card-new">
              <div className="offer-tag">{offer.category}</div>
              <div className="offer-image">
                <div className="imgslot" data-label={offer.image}>
                  <img src={offer.image} alt={offer.title} onError={(e) => (e.target.style.display = 'none')} />
                </div>
              </div>
              <div className="offer-content">
                <p className="tcs-tag">{offer.tag}</p>
                <h3>{offer.title}</h3>
                <p className="offer-desc">{offer.description}</p>
                <button className="offer-btn">{offer.button}</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
